import type { ReadConfig } from 'api-read-hook';
import type { HydraCollection } from '../../types';

import { useApiRead } from 'api-read-hook';
import { makeQueryString } from '../../util';
import * as MediaUpload from './MediaUpload';

export type V_DetailAsAdmin = {
  '@id': string;
  '@type': 'WeeklyTask';
  id: string;
  title: string;
  resourceTitle: string;
  position: number;
  description: string;
  image: MediaUpload.BaseView | null;
  publishedAt: string | null;
};

export type V_ProgramWeekSub = {
  '@id': string;
  '@type': 'WeeklyTask';
  id: string;
  title: string;
  resourceTitle: string;
  position: number;
  publishedAt: string | null;
  updatedAt: string | null;
};

export type W = {
  title: string;
  resourceTitle: string;
  position: number;
  description: string;
  image: string | null;
  week: string;
};

export function useReadCollectionWeeklyTasks(
  id: string,
  queryParams?: { 'order[position]'?: string; title?: string },
  options?: ReadConfig,
) {
  return useApiRead<HydraCollection<V_ProgramWeekSub>>(
    `/program-weeks/${id}/weekly-tasks${makeQueryString(queryParams)}`,
    options,
  );
}

export function useReadItem(id: string, options?: ReadConfig) {
  return useApiRead<V_DetailAsAdmin>(`/weekly-tasks/${id}`, options);
}
